import { divide } from "mathjs";

export const formattedPrice = (price) => {

    if (!price) return 0;

    const dividedPrice = divide(price, 100);

    if (Number.isInteger(dividedPrice)) {
        return dividedPrice.toString();
    }
    
    return dividedPrice.toFixed(2);
}

export const formattedPriceNumber = (price) => {

    if (!price) return 0;

    return divide(price, 100);
}